import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NavigationEnd, Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { OrganizationService } from './organization.service';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class AccessLogService {
  constructor(
    private router: Router,
    private organizationService: OrganizationService,
    private userService: UserService,
    private firestore: AngularFirestore,
    private ngxPermissionsService: NgxPermissionsService
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (!environment.features.accessLogEnabled) {
          return;
        }

        if (
          event.urlAfterRedirects.includes('/login') ||
          event.urlAfterRedirects.includes('/organization') ||
          event.urlAfterRedirects.includes('/home')
        ) {
          return;
        }

        this.registerAccessLog(
          event.urlAfterRedirects,
          this.organizationService.currentOrganization.alias
        ).catch(error => {
          throw error;
        });
      });
  }

  public async logManualNavigation(url: string): Promise<void> {
    await this.registerAccessLog(
      url,
      this.organizationService.currentOrganization.alias
    );
  }

  private async registerAccessLog(
    url: string,
    organization: string
  ): Promise<void> {
    const body = {
      user: this.userService.currentUser.id,
      organization,
      route: url,
      accessDate: new Date(),
    };

    await this.firestore
      .collection('access-logs')
      .add(body)
      .then(async () => {
        await this.ngxPermissionsService
          .hasPermission(['ADMIN', 'INTERNAL'])
          .then(data => {
            if (data) {
            }
          });
      });
  }
}
